import { render, staticRenderFns } from "./customerLvyueTable2023.vue?vue&type=template&id=2edc6075"
import script from "./customerLvyueTable2023.vue?vue&type=script&lang=js"
export * from "./customerLvyueTable2023.vue?vue&type=script&lang=js"
import style0 from "./customerLvyueTable2023.vue?vue&type=style&index=0&id=2edc6075&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports